import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { AccountLockBannerComponent, OrganizationStoreService } from '@rms/org';
import { VexProgressBarComponent } from '@vex/components/vex-progress-bar/vex-progress-bar.component';
import { VexSidebarComponent } from '@vex/components/vex-sidebar/vex-sidebar.component';
import { VexConfig } from '@vex/config/vex-config.interface';
import { VexConfigService } from '@vex/config/vex-config.service';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseLayoutComponent } from '../base-layout/base-layout.component';
import { ConfigPanelComponent } from '../components/config-panel/config-panel.component';
import { FooterComponent } from '../components/footer/footer.component';
import { QuickpanelComponent } from '../components/quickpanel/quickpanel.component';
import { SidenavComponent } from '../components/sidenav/sidenav.component';
import { SearchComponent } from '../components/toolbar/search/search.component';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';

@Component({
  selector: 'rms-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [
    AccountLockBannerComponent,
    BaseLayoutComponent,
    AsyncPipe,
    SidenavComponent,
    ToolbarComponent,
    FooterComponent,
    QuickpanelComponent,
    VexSidebarComponent,
    ConfigPanelComponent,
    MatDialogModule,
    MatSidenavModule,
    RouterOutlet,
    SearchComponent,
    VexProgressBarComponent,
  ],
})
export class LayoutComponent {
  private readonly layoutService = inject(VexLayoutService);
  private readonly configService = inject(VexConfigService);
  private readonly organizationStore = inject(OrganizationStoreService);

  config$: Observable<VexConfig> = this.configService.config$;
  public isLocked$: Observable<boolean> = this.organizationStore.isLocked$;
  sidenavCollapsed$: Observable<boolean> = this.layoutService.sidenavCollapsed$;
  sidenavDisableClose$: Observable<boolean> = this.layoutService.isDesktop$;
  sidenavFixedInViewport$: Observable<boolean> = this.layoutService.isDesktop$.pipe(map((isDesktop) => !isDesktop));
  sidenavMode$: Observable<MatDrawerMode> = combineLatest([
    this.layoutService.isDesktop$,
    this.configService.select((config) => config.layout),
  ]).pipe(map(([isDesktop, layout]) => (!isDesktop || layout === 'vertical' ? 'over' : 'side')));

  sidenavOpen$: Observable<boolean> = this.layoutService.sidenavOpen$;
  configPanelOpen$: Observable<boolean> = this.layoutService.configPanelOpen$;
  quickpanelOpen$: Observable<boolean> = this.layoutService.quickpanelOpen$;

  onSidenavClosed(): void {
    this.layoutService.closeSidenav();
  }

  onQuickpanelClosed(): void {
    this.layoutService.closeQuickpanel();
  }
}
